import io from 'socket.io-client';

const ENDPOINT = process.env.REACT_APP_SOCKET_ENDPOINT as string;
const socketconnection = io(ENDPOINT);
console.debug('SOCKET ENDPOINT', process.env.REACT_APP_SOCKET_ENDPOINT);

export const socket = socketconnection;
